import React from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { NeritFrameworkRoutingHelper } from 'submodules/nerit-framework-ui/common/router/utils/NeritFrameworkRoutingHelper'
import { PrivateRouter } from 'app/routers/private/PrivateRouter'
import { SCREEN_FILTER_URL_PARAM } from 'submodules/nerit-framework-ui/common/screens/inner/ScreenTypes'

interface ICPProps {
    samplingCode: number
}

export function ButtonGoToDataAnalysisCP(props: ICPProps): JSX.Element {
    const goToDataAnalysis = () => {
        const filterDto = { samplingCode: props.samplingCode }
        const url = `${PrivateRouter.DATA_ANALISYS}?${SCREEN_FILTER_URL_PARAM}=${JSON.stringify(filterDto)}`
        NeritFrameworkRoutingHelper.historyPush(url)
    }

    return (
        <ButtonCP
            size={'small'}
            icon={'bar-chart'}
            onClick={goToDataAnalysis}
            tooltip={'Ir para Análise de Dados'}
        >
            Análise
        </ButtonCP>
    )
} 